module.exports = __webpack_public_path__ + "static/media/next.a320babc.svg";